import $ from 'jquery';

import loadingTMPL from './views/loading.tmpl';
import SideBar from './views/sidebar/SideBar.es6';
import Archive from './models/Archive.es6';

import Mapp from './views/map/Map.es6';
// import Mapp from './views/map/GLMap';
import Config from './models/Config.es6';
import configFile from '../data/config.json5';

class Application {

  constructor() {
    this._$container = $('<div id="container"></div>').appendTo('BODY');
    this._$loading = $(loadingTMPL()).appendTo('BODY');
    this._$preloading = $('#preloading');
    this._$preloading.find('.msg').after("<span class='msg'>loading metadata</span>");

    new Config(configFile).loadData().then(
      conf => {
        console.info('CONFIG data loaded');
        this.config = conf;
        return new Archive(conf.archive, conf.global).loadFacetsMetadata();
      },
      error => {
        console.warn('error loading config data');
        throw error;
      }
    ).then(
      archive => {
        console.info('ARCHIVE metadata loaded');
        this.archive = archive;
        this.archive.queryStarted.add(() => this._onArchiveQueryStarted());
        this._init();
      },
      error => {
        console.warn('error loading archive data');
        throw error;
      }
    ).catch(
      error => {
        console.warn('caught error');
        throw error;
      }
    );
  }

  _init() {
    console.info('init');
    this._$preloading.hide();
    this.archive.query();
    this.map = new Mapp(this._$container, this.archive, this.config);
    this.map.updated.add(() => this._onMapUpdated());
    this.sidebar = new SideBar(this._$container, this.archive, this.config);
    this.sidebar.hovered.add(() => this._onSidebarHovered());
  }

  _onMapUpdated() {
    this._$loading.hide();
  }

  _onSidebarHovered() {
    this.map.hideTooltip();
  }

  _onArchiveQueryStarted() {
    this._$loading.show();
  }

}

module.exports = Application;



/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/js/App.es6
 **/